export default "__VITE_ASSET__WPpfYd_H__"